/**
 * Editor preferences type definitions for the songwriting app.
 * These preferences control the AI feedback system's stress and rhyme displays.
 */

export interface StressPreferences {
  enabled: boolean;
  showUnstressed: boolean;
  showSecondary: boolean;
  showStressCount: boolean;
}

export interface RhymePreferences {
  enabled: boolean;
  showLabels: boolean;
  /**
   * @deprecated AI rhyme suggestions feature has been removed.
   * This field is retained for backward compatibility with existing stored preferences.
   * It has no runtime effect - do not use in new code.
   */
  suggestions: {
    enabled: boolean;
  };
}

export interface SectionPreferences {
  showValidation: boolean;
  showLineStability: boolean;
}

export interface FeedbackPreferences {
  stress: StressPreferences;
  rhyme: RhymePreferences;
  section: SectionPreferences;
}

export interface DisplayPreferences {
  theme: string;
  fontSize: number;
}

export interface EditorPreferences {
  feedback: FeedbackPreferences;
  display: DisplayPreferences;
}

/**
 * Returns sensible default preferences.
 * Used for new users or when preferences can't be loaded.
 */
export function getDefaultPreferences(): EditorPreferences {
  return {
    feedback: {
      stress: {
        enabled: true,
        showUnstressed: false,
        showSecondary: true,
        showStressCount: true,
      },
      rhyme: {
        enabled: true,
        showLabels: true,
        suggestions: {
          enabled: true,
        },
      },
      section: {
        showValidation: true,
        showLineStability: false,
      },
    },
    display: {
      theme: 'default',
      fontSize: 16,
    },
  };
}
